<template>
  <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Název protokolu' | translate">
      {{ entity.name }}
    </td>
    <td :data-th="'Kód protokolu' | translate">
      {{ entity.code }}
    </td>
    <td :data-th="'Prefix' | translate">
      {{ entity.prefix }}
    </td>
    <td :data-th="'Port' | translate">
      {{ entity.port }}
    </td>
    <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
    <td :data-th="'Upraveno' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_deleteActionAllowed"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteProtocol">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"

export default {
  name: "ProtocolRow",
  mixins: [rowActions],
  props: {
    entity: Object,
  },
  data() {
    return {
      moduleName: 'protocols',
      detailPageRouteName: 'protocolDetail',
    }
  },
  methods: {
    emitDeleteProtocol() {
      this.$emit('deleteProtocol', String(this.entity.id))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/protocols/ProtocolRow.vue